import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Footer from '../components/Footer';

const ADMIN_EMAIL = 'admin@championmaker.com';
const ADMIN_PASSWORD = 'Admin@2026';

function AdminLogin() {
  const navigate = useNavigate();
  const [formData, setFormData] = useState({
    email: '',
    password: ''
  });
  const [errorMessage, setErrorMessage] = useState('');
  const [successMessage, setSuccessMessage] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);

  useEffect(() => {
    const isAuthenticated = sessionStorage.getItem('adminAuthenticated') === 'true';
    if (isAuthenticated) {
      navigate('/admin/dashboard');
    }
  }, [navigate]);

  const handleChange = (event) => {
    const { name, value } = event.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value
    }));
    if (errorMessage) {
      setErrorMessage('');
    }
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    setErrorMessage('');
    setSuccessMessage('');
    setIsSubmitting(true);

    const email = formData.email.trim().toLowerCase();
    const password = formData.password;
    const isValid = email === ADMIN_EMAIL && password === ADMIN_PASSWORD;

    if (!isValid) {
      setErrorMessage('Invalid admin credentials.');
      setIsSubmitting(false);
      return;
    }

    sessionStorage.setItem('adminAuthenticated', 'true');
    sessionStorage.setItem('adminEmail', ADMIN_EMAIL);
    setSuccessMessage('Login successful. Redirecting...');
    setTimeout(() => {
      navigate('/admin/dashboard');
    }, 800);
  };

  return (
    <div className="App">
      <section className="booking-form-section">
        <div className="container">
          <div
            style={{
              maxWidth: '480px',
              margin: '0 auto',
              padding: '2rem',
              background: '#ffffff',
              borderRadius: '12px',
              boxShadow: '0 12px 30px rgba(0, 0, 0, 0.08)'
            }}
          >
            <h1 className="section-heading" style={{ marginBottom: '0.5rem' }}>
              Admin Login
            </h1>
            <p style={{ marginBottom: '1.5rem', color: '#6b7280' }}>
              Sign in with your admin account.
            </p>

            <form onSubmit={handleSubmit} className="booking-form">
              <div className="form-group">
                <label htmlFor="email">Email</label>
                <input
                  id="email"
                  name="email"
                  type="email"
                  className="admin-login-input"
                  value={formData.email}
                  onChange={handleChange}
                  required
                  autoComplete="email"
                  placeholder="admin@example.com"
                />
              </div>

              <div className="form-group">
                <label htmlFor="password">Password</label>
                <input
                  id="password"
                  name="password"
                  type="password"
                  className="admin-login-input"
                  value={formData.password}
                  onChange={handleChange}
                  required
                  autoComplete="current-password"
                  placeholder="Enter your password"
                />
              </div>

              {errorMessage && (
                <p className="error-message" style={{ marginBottom: '1rem' }}>
                  {errorMessage}
                </p>
              )}

              {successMessage && (
                <p style={{ color: '#059669', marginBottom: '1rem' }}>{successMessage}</p>
              )}

              <button
                type="submit"
                className="btn-primary btn-submit"
                disabled={isSubmitting}
              >
                {isSubmitting ? 'Signing in...' : 'Sign In'}
              </button>
            </form>
          </div>
        </div>
      </section>
      <Footer />
    </div>
  );
}

export default AdminLogin;
